import { generateUnOrderedList } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc68 = {
    title: "Image 68: Examples of pass-through lockers, refrigerators, and Compact Storage Systems for storing evidence at the Bellevue Police Department, Washington (US) and the Oswego Police Department, New York (US).",
    para1: <>
        <p>This image has two pictures showing examples of lockers, refrigerators and compact storage systems for the storage of evidence. The shelves are grey and appear to be made of metal. There are several boxes stored on each of the shelves.</p>
        <p>The image below also shows a compact storage wall at which evidence is dropped off to be categorised and stored in segregated storage. The lockers are also grey and made of metal. They have padlocks on the doors.</p>
    </>,
}

export const FigureDesc65 = {
    title: "Figure 65: Typical floor plan of an Evidence Room.",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The entrance to the evidence room is at the bottom left corner of the floor plan. The features of the figure are described in an anti-clockwise manner from the entrance.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The entrance to the evidence room has controlled access. The corridor outside the evidence locker has a CCTV camera to monitor the movement of people entering the room.",
                    "Opposite to the entrance is a counter for the person manning the evidence being entered and a two way locker storage. The counter is equipped with a table and two chairs placed opposite each other. The table has a computer system.",
                    "The two way locker storage is beside the chair to the right of the counter.",
                    "Additional storage has been provided to the left of the table at the counter for storage of personal effects used by the clerks.",
                    "Below the two way locker storage an access door has been provided that leads into the evidence room.",
                    "Opposite the entrance door, is a large evidence storage shelf (which is at the bottom right of the floor plan). ",
                    "Opposite to the large evidence storage are additional storage shelves. These shelves are Mobile Compactor Storage units which can be compressed and expanded on a railing system.",
                    "There is a weapons evidence storage room on the top right corner of the figure, with an access door. Next to this room is a drug evidence storage room. These two rooms have storage space provided at a right angle.",
                    "Beside the drug evidence storage room is a strong room, with an access door. The strong room has storage cupboards on both its top and bottom walls.",
                    "Below the strong room, is a clerks room along with a computerised table and a chair. There is a refrigerator next to the clerks table.",
                    "There are strategically placed CCTV cameras throughout the room.",
                    "The entire room is designed to have accessible aisle space for movement.",

                ])}
            </div>
        </p>
    </>
}

